Vue.directive('click-outside', {
  
  bind: function(el, binding, vnode) {
      this.handleOutsideClick = function(event) { 
        if (vnode.context[binding.expression]) {
          vnode.context[binding.expression](event);
        }
      };
      this.handleInsideClick = function(event) {
          event.stopPropagation();
      };
      this.handleEscapeKey = function(event) {
        if (event.keyCode == 27) {
          vnode.context[binding.expression](event);
        }
      };
      el.addEventListener('click', this.handleInsideClick);
      document.body.addEventListener('click', this.handleOutsideClick);
      document.addEventListener('keyup', this.handleEscapeKey); 
  },   
  unbind: function(el) {
    el.removeEventListener('click', this.handleInsideClick);
    document.body.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keyup', this.handleEscapeKey); 
  },

});

